module.exports = __webpack_public_path__ + "fde3997ec701ab84d71af99db46e10b6.MP3";